import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router";
import { CustomersPageContainer } from "@charphq/ui/components/layout/pages/CustomersPageContainer";

export const Route = createFileRoute("/customers")({
  component: CustomersPageComponent,
  // SearchSchemaInput marker + all-optional output: navigations to this route
  // (and its nested detail/contacts routes) never require a `search` prop; the
  // URL sync hook applies defaults (page 1, size 50).
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => ({
    page: search.page ? Number(search.page) : undefined,
    pageSize: search.pageSize ? Number(search.pageSize) : undefined,
    sortBy: (search.sortBy as string) || undefined,
    sortDirection: (search.sortDirection as "asc" | "desc") || undefined,
    globalFilter: (search.globalFilter as string) || undefined,
    columnFilters: (search.columnFilters as Record<string, unknown>) || undefined,
  }),
});

function CustomersPageComponent() {
  return (
    <CustomersPageContainer
      route={Route}
      breadcrumbs={[{ label: "Home", href: "/" }, { label: "Customers" }]}
    />
  );
}
